
export enum SessionTimeoutState {
  Fine = 0,// Session is not close to expiry
  ExpiringRefreshInBackground = 1,// Session is close to expiry, and should be refreshed
  ExpiringSoon = 2,// Session is very close to expiry, and use should be prompted to refresh
  Expired = 3 // Session is expired, and user should be logged out
}
